/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import {
  action_settings,
  hide_view,
  wallet_settings,
} from "../../../../utils/helpers/objectHelpers";
// import Action from "./atom/Action";
import HideView from "./atom/HideView";
// import WalletFlow from "./atom/WalletSettings";

function Body({ domainBrand, hideView }) {
  const dictionary = domainBrand.domainBrand["languageDictionary"];

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary ? dictionary["WO_WORKFLO_-434837466"] : "Workflow"}
            </h1>
          </div>
        </div>

        <div className="row row-sm">
          <div className="col-lg-12 col-md-12">
            <HideView dictionary={dictionary} hideViewValues={hideView} />
            {/* <WalletFlow dictionary={dictionary} /> */}
            {/* <Action dictionary={dictionary} /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Body;
